export const breadcrumb = [
    { path: '/', parent: 'Dashboard', label: 'Dashboard' },
    // { path: '/organization', parent: 'Organization', label: 'Organization Master' },
    { path: '/boards', parent: 'Boards', label: 'Boards List' },
    { path: '/branch', parent: 'Branch Master', label: 'Branch Master' },
    { path: '/admission-create', parent: 'Admission', label: 'Admission Create' },
    { path: '/academic-years', parent: 'Admission', label: 'Academic Years' },
    { path: '/admission-types', parent: 'Admission', label: 'Admission Types' },
    { path: '/application-fees', parent: 'Admission', label: 'Application Fees' },
    { path: '/admission-courses', parent: 'Admission', label: 'Admission Courses' },
    { path: '/admissiondashboard', parent: 'Admission', label: 'Dashboard' },
    { path: '/multistageconversiongraphs', parent: 'Admission', label: 'Multi Stage Conversion Graph' },
    { path: '/individualApplicantTimelineReport', parent: 'Admission', label: 'Applicant Timeline (hrs)' },
    { path: "/funnelreport", parent: 'Admission', label: 'Weekly/Monthly Funnel Report' },
    { path: '/bus-fee-plans', parent: 'Finance', label: 'Bus Fee plans' },
    { path: '/fee-collect', parent: 'Finance', label: 'Fee Collect' },
    { path: '/fee-day-sheet', parent: 'Finance', label: 'Fee Day Sheet' },
    { path: '/fee-types', parent: 'Finance', label: 'Fee Types' },
    { path: '/fee-plans', parent: 'Finance', label: 'Fee Plans' },
    { path: '/vehicle-management', parent: 'Transport', label: 'Vehicle Management' },
    { path: '/transport-staff-management', parent: 'Transport', label: 'Transport Staff Management' },
    { path: '/route-management', parent: 'Transport', label: 'Route Management' },
    { path: '/transport-attendance', parent: 'Transport', label: 'Transport Attendence' },
    { path: '/transport-attendance-report', parent: 'Transport', label: 'Transport Attendence Report' },
    { path: '/approvals-assigntransport', parent: 'Approvals', label: 'Assign Transports' },
    { path: '/approvals-transportroute', parent: 'Approvals', label: 'Transport Route' },
    { path: '/transportfeereport', parent: 'Transport', label: 'Transport Fee Report' },
    { path: '/routeUtilizationreport', parent: 'Transport', label: 'Route Utilization Report' },
    { path: '/transportdashboard', parent: 'Transport', label: 'Dashboard' },
    { path: '/curriculum', parent: 'CurriculumMaster', label: 'Curriculum Master' },
    { path: '/assign-content', parent: 'Assign Content', label: 'Assign Content' },
    { path: '/assign-content', parent: 'Assign Content', label: 'Assign Content' },
    { path: '/content', parent: 'Contetn master', label: 'Content Master' },
    { path: '/question-bank', parent: 'Examination', label: 'Question Bank' },
    { path: '/assign-question', parent: 'Examination', label: 'Assign Questions' },
    { path: '/examination', parent: 'Examination', label: 'Exams' },
    { path: '/discussion-board', parent: 'Discussion Board', label: 'Discussion Board' },
    { path: '/askadoubt', parent: 'Ask a Doubt', label: 'Ask a Doubt' },
    { path: '/transportManagement', parent: 'Transport Management', label: 'Transport Management' },
    { path: '/admin-manage', parent: 'Admin Management', label: 'Admin Management' },
    { path: '/admins-bulkupload', parent: 'Admin Management', label: 'Bulk Upload' },
    { path: '/rolesAndUsers', parent: 'Settings', label: 'RolesAndUsers' },
    { path: '/finance', parent: 'Settings', label: 'Finance' },
    { path: '/UnAssignFee', parent: 'Finance', label: 'UnAssignFee' },
    { path: '/staff', parent: 'Settings', label: 'Staff Management' },

    { path: '/formlayout', parent: 'UI Kit', label: 'Form Layout' },
    { path: '/input', parent: 'UI Kit', label: 'Input' },
    { path: '/floatlabel', parent: 'UI Kit', label: 'Float Label' },
    { path: '/invalidstate', parent: 'UI Kit', label: 'Invalid State' },
    { path: '/button', parent: 'UI Kit', label: 'Button' },
    { path: '/table', parent: 'UI Kit', label: 'Table' },
    { path: '/list', parent: 'UI Kit', label: 'List' },
    { path: '/tree', parent: 'UI Kit', label: 'Tree' },
    { path: '/panel', parent: 'UI Kit', label: 'Panel' },
    { path: '/overlay', parent: 'UI Kit', label: 'Overlay' },
    { path: '/media', parent: 'UI Kit', label: 'Media' },
    { path: '/menu', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/seat', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/payment', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/confirmation', parent: 'UI Kit', label: 'Menu' },
    { path: '/messages', parent: 'UI Kit', label: 'Messages' },
    { path: '/file', parent: 'UI Kit', label: 'File' },
    { path: '/chart', parent: 'UI Kit', label: 'Charts' },
    { path: '/misc', parent: 'UI Kit', label: 'Misc' },
    { path: '/icons', parent: 'Utilities', label: 'Icons' },
    { path: '/blocks', parent: 'PrimeBlocks', label: 'Blocks' },
    { path: '/crud', parent: 'Utilities', label: 'Crud' },
    { path: '/calendar', parent: 'PrimeBlocks', label: 'Calendar' },
    { path: '/timeline', parent: 'Pages', label: 'Timeline' },
    { path: '/invoice', parent: 'Pages', label: 'Invoice' },
    { path: '/help', parent: 'Pages', label: 'Help' },
    { path: '/empty', parent: 'Pages', label: 'Empty Page' },
    { path: '/documentation', parent: 'Pages', label: 'Documentation' },

    { path: '/', parent: 'PrimeBlocks', label: 'Dashboard' },
    { path: '/newusers', parent: 'PrimeBlocks', label: 'New users' },
    { path: '/users', parent: 'PrimeBlocks', label: 'Users' },
    { path: '/parents', parent: 'PrimeBlocks', label: 'Parents' },
    { path: '/leaves', parent: 'PrimeBlocks', label: 'Leaves' },
    { path: '/calendar', parent: 'PrimeBlocks', label: 'Calendar' },
    { path: '/user-management', parent: 'PrimeBlocks', label: 'User ManageMent' },
    { path: '/user-bulkupload', parent: 'PrimeBlocks', label: 'Bulk Upload' },
    { path: '/ticket-management', parent: 'PrimeBlocks', label: 'Ticket Management' },
    { path: '/admissionManagement', parent: 'Home', label: 'Admission' },
    { path: '/schoolSetup', parent: 'Home', label: 'School Setup' },
    { path: '/notifications', parent: 'PrimeBlocks', label: 'Notification Management' },
    { path: '/feesetup', parent: 'Home', label: 'Finance' },
    { path: '/financeGeneralSettings', parent: 'Home', label: 'Finance General Settings' },
    { path: '/feeDecisionDashboard', parent: 'Fee Decision', label: 'Dashboard' },
    { path: '/financeNew/RiskOverview', parent: 'Fee Decision', label: 'Risk Scoring' },
    { path: '/financeNew/RiskConfiguration', parent: 'Fee Decision', label: 'Risk Configuration' },
    { path: '/financeNew/FeeLedger', parent: 'Fee Decision', label: 'Fee Ledger' },
    { path: '/financeNew/DiscountDisparity', parent: 'Fee Decision', label: 'Discount Disparity' },
    { path: '/financeNew/DiscountContext', parent: 'Fee Decision', label: 'Discount Context' },
    { path: '/financeNew/CollectionForecast', parent: 'Fee Decision', label: 'Collection Forecast' },
    { path: '/financeNew/DefaultProbability', parent: 'Fee Decision', label: 'Default Probability' },
    { path: '/financeNew/ActionQueue', parent: 'Fee Decision', label: 'Action Queue' },
    { path: '/financeNew/ApprovalRequests', parent: 'Fee Decision', label: 'Action Approvals' },
    { path: '/financeNew/CallTasks', parent: 'Fee Decision', label: 'Call Tasks' },
    { path: '/financeNew/CallOutcomesLog', parent: 'Fee Decision', label: 'Call Outcomes Log' },
    { path: '/financeNew/PayerProfiles', parent: 'Fee Decision', label: 'Payer Profiles' },
    { path: '/financeNew/PrimaryContacts', parent: 'Fee Decision', label: 'Primary Contacts' },
    { path: '/financeNew/PromisesBreaches', parent: 'Fee Decision', label: 'Promises & Breaches' },
    { path: '/financeNew/RiskAdjustmentHistory', parent: 'Fee Decision', label: 'Risk Adjustment History' },
    { path: '/financeNew/ActionQueueManagement', parent: 'Fee Decision', label: 'Action Queue Management' },
    { path: '/financeNew/RiskScoreApprovals', parent: 'Fee Decision', label: 'Risk Score Approvals' },
    { path: '/financeNew/ActionEffectiveness', parent: 'Fee Decision', label: 'Action Effectiveness' },
    { path: '/financeNew/ChannelLearning', parent: 'Fee Decision', label: 'Channel Learning' },
    { path: '/financeNew/AuditTrail', parent: 'Fee Decision', label: 'Audit Trail' },
    { path: '/financeNew/DataIntegrityReport', parent: 'Fee Decision', label: 'Data Integrity Report' },
    { path: '/finance-bulk-upload', parent: 'Fee Decision', label: 'Bulk Upload' },

    { path: '/acadamics', parent: 'Home', label: 'Academics' },

    { path: '/studentInfo', parent: 'Students', label: 'Student Information' },
    { path: '/studentinforeport', parent: 'Students', label: 'Student Information Report' },
    { path: '/studentstatuschangereport', parent: 'Students', label: 'Student Status Change Report' },
    { path: '/studentsattendancereport', parent: 'Students', label: 'Student Attendance' },
    { path: '/attendancesummaryreport', parent: 'Students', label: 'Attendance Summary Report' },
    { path: '/userBulkupload', parent: 'Students', label: 'Student BulkUpload' },
    { path: '/studentsdashboard', parent: 'Students', label: 'Dashboard' },
    { path: '/attendance', parent: 'Students', label: 'Attendance' },
    { path: '/studentTransfer', parent: 'Students', label: 'Student Transfer' },
    { path: '/transferPendingStudents', parent: 'Approvals', label: 'Student Transfer' },
    { path: '/studentProfile', parent: 'Students', label: 'Student Profile' },

    // { path: '/TeacherDiaryTemplate', parent: 'Academics', label: 'Teacher Diary Template' },
    { path: '/AcademicCalendar', parent: 'Academics', label: 'AcademicCalendar' },
    // { path: '/TeacherDiary', parent: 'Academics', label: 'Teacher Diary' },
    { path: '/DigitalLibrary', parent: 'Academics', label: 'Digital Library' },
    { path: '/SubjectAssignment', parent: 'Academics', label: 'Subject Assignment' },
    { path: '/GradingScheme', parent: 'Academics', label: 'Grading Scheme' },
    { path: '/SubjectiveExamination', parent: 'Academics', label: 'Subjective Examination' },
    { path: '/CreateTest', parent: 'Examination', label: 'Create Test' },
    { path: '/QuestionBank', parent: 'Examination', label: 'Question Bank' },
    { path: '/CreateTestType', parent: 'Examination', label: 'Create Test Type' },
    { path: '/CreateTemplate', parent: 'Examination', label: 'Create Template' },
    { path: '/TestsandExams', parent: 'Examination', label: 'Tests and Exams' },
    { path: '/academicsDashboard', parent: 'Academics', label: 'Dashboard' },
    { path: '/branchAnalysisReport', parent: 'Academics', label: 'Branch Analysis' },
    { path: '/errorAnalysisReport', parent: 'Academics', label: 'Error Analysis' },
    { path: '/studentErrorReport', parent: 'Academics', label: 'Student Error Report' },
    { path: '/cumulativeAnalysis', parent: 'Academics', label: 'Cumulative Analysis' },
    { path: '/branchWiseMarksReport', parent: 'Academics', label: 'Branch Wise Highest Marks Average' },
    { path: '/studentWiseErrorsReport', parent: 'Academics', label: 'Errors List Report (Student Wise)' },
    { path: '/sectionWiseExamAnalysisReport', parent: 'Academics', label: 'Section Wise Exam Analysis' },
    { path: '/studentSubjectWiseMarksReport', parent: 'Academics', label: 'Students Subject Wise Marks' },
    { path: '/objectiveExamsReport', parent: 'Academics', label: 'Objective Exams Branch Wise Rank Analysis' },
    { path: '/subjectiveExamTotalReport', parent: 'Academics', label: 'Subjective Exam Total Report' },
    { path: '/marksEntryStatus', parent: 'Academics', label: 'Marks Entry Status Report' },

    { path: '/GradingSystem', parent: 'Prograss Reports', label: 'Grading System' },
    { path: '/PerformanceAnalytics', parent: 'Prograss Reports', label: 'Performance Analytics' },
    { path: '/GradeBookTemplate', parent: 'Prograss Reports', label: 'Grade Book Template' },
    { path: '/GradeBook', parent: 'Prograss Reports', label: 'Grade Book' },
    { path: '/ApprovalHierarchy', parent: 'Academics', label: 'Approval Hierarchy' },
    { path: '/Reports', parent: 'Academics', label: 'Reports' },
    { path: '/myTimeTable', parent: 'Timetable', label: 'My Timetable' },
    { path: '/requestSubstitution', parent: 'Timetable', label: 'Request Substitution' },
    { path: '/lagReport', parent: 'Timetable', label: 'Lag Report' },
    { path: '/timeTableReports', parent: 'Timetable', label: 'TimeTable Reports' },
    { path: '/enquiry', parent: 'Admissions', label: 'Enquiry Form' },
    { path: '/addEnquiry', parent: 'Enquiry', label: 'Add Enquiry' },
    { path: '/application', parent: 'Admissions', label: 'Application' },
    { path: '/collectFee', parent: 'Finance', label: 'CollectFee' },
    { path: '/adHocCharges', parent: 'Finance', label: 'Ad Hoc Charges' },
    { path: "/financeDashboard", parent: "Finance", label: "Dashboard" },
    { path: '/assignFee', parent: 'Finance', label: 'AssignFee' },
    { path: '/feeConcession', parent: 'Finance', label: 'Concession' },
    { path: '/feecollectionreport', parent: 'Finance', label: 'Fee Collection Report' },
    { path: '/refundreport', parent: 'Finance', label: 'Refund Report' },
    { path: '/unassignreports', parent: 'Finance', label: 'Unassign Reports' },
    { path: '/feeduereport', parent: 'Finance', label: 'Fee Due Report' },
    { path: '/feeconcessionreport', parent: 'Finance', label: 'Fee Concession Report' },
    { path: '/agewisefeeduereport', parent: 'Finance', label: 'Age Wise Fee Due Report' },
    { path: '/feeRefund', parent: 'Finance', label: 'Refund' },
    { path: "/chequeOrDDstatus", parent: "Finance", label: "(Cheque/DD) Status" },
    { path: '/admission-application', parent: 'Admissions', label: 'Application' },
    { path: '/communicate-notification', parent: 'Communicate', label: 'Notification' },
    // { path: '/communicate-approvals', parent: 'Communicate', label: 'Communication Approvals' },
    { path: '/templates-management', parent: 'Communicate', label: 'Templates Management' },
    { path: '/notification-workflows', parent: 'Communicate', label: 'Notification Workflows' },
    { path: '/fee-decision-notification-workflows', parent: 'Communicate', label: 'Fee Decision Notification Workflow' },
    { path: '/communicate-dashboard', parent: 'Communicate', label: 'Dashboard' },
    { path: '/approval-hierarchy-status-change', parent: 'Approval Hierarchy', label: 'Status Change' },
    { path: '/approval-hierarchy-student-transfer', parent: 'Approval Hierarchy', label: 'Student Transfer' },
    { path: '/approval-hierarchy-fee-concession', parent: 'Approval Hierarchy', label: 'Fee Concession' },
    { path: '/approval-hierarchy-substitution-request', parent: 'Approval Hierarchy', label: 'Substitution Request' },
    { path: '/approvals-receipt-modification', parent: 'Approval Hierarchy', label: 'Receipt Modification' },

    { path: '/approval-hierarchy-assign-transport', parent: 'Approval Hierarchy', label: 'Assign Transport' },
    { path: '/approval-hierarchy-transport-route', parent: 'Approval Hierarchy', label: 'Transport Route' },
    { path: '/approval-hierarchy-fee-unassign', parent: 'Approval Hierarchy', label: 'Fee Unassign' },
    { path: '/approval-hierarchy-fee-refund', parent: 'Approval Hierarchy', label: 'Fee Refund' },
    { path: '/approval-hierarchy-receipt-modification', parent: 'Approval Hierarchy', label: 'Receipt Modification' },
    { path: '/approval-hierarchy-student-promotions', parent: 'Approval Hierarchy', label: 'Student Promotions' },
    { path: '/admission-exam', parent: 'Admissions', label: 'Exam' },
    { path: '/addExam', parent: 'Exam', label: 'Add Exam' },
    { path: '/admission-registration', parent: 'Admissions', label: 'Registration Form' },
    { path: '/addRegistration', parent: 'Admissions', label: 'Add Registration' },
    { path: '/admission-enrollment', parent: 'Admissions', label: 'Enrollment' },
    { path: '/confirm-enrollment', parent: 'Admissions', label: 'Confirm Enrollment' },
    { path: '/approvals-fee-concession', parent: 'Approvals', label: 'Fee concession' },
    { path: '/approvals-fee-refund', parent: 'Approvals', label: 'Fee Refund' },
    { path: '/approvals-Fee-unassign', parent: 'Approvals', label: 'Fee Unassign' },
    { path: '/approvals-studentTransfer', parent: 'Approvals', label: 'Student Transfer' },
    { path: '/approvals-studentstatuschange', parent: 'Approvals', label: 'Student Status Change' },
    { path: '/approvals-substitutionrequest', parent: 'Approvals', label: 'Substitution Request' },
    { path: '/studentStatusChange', parent: 'Student', label: 'Student Status Change' },
    { path: '/closedConcessionApprovals', parent: 'Approvals', label: 'Fee Concession Report' },
    { path: '/closedRefundApprovals', parent: 'Approvals', label: 'Fee Refund Report' },
    { path: '/closedUnassignApprovals', parent: 'Approvals', label: 'Fee Unassign Report' },
    { path: '/assigntransport', parent: 'Transport', label: 'Assign Transport' },
    { path: '/transportfeereceivables', parent: 'Transport', label: 'Transport Fee Receivables' },
    { path: '/routemanagement', parent: 'Transport', label: 'Route Management' },
    { path: '/settimetable', parent: 'Settings', label: 'Time Table' },
    { path: '/organization-setup', parent: 'Organization', label: 'Organization Master' },
    { path: '/create-organization', parent: 'Organization', label: 'Create Organization' },
    { path: '/promotions', parent: 'Settings', label: 'Promotions' },
    { path: '/transactions-list', parent: 'Settings', label: 'Transactions' },
    { path: '/studentPromotion', parent: 'Student', label: 'Student Promotion' },
    { path: '/approvals-studentpromotions', parent: 'Approvals', label: 'Student Promotions' },
    { path: '/academicYearTransfer', parent: 'Settings', label: 'Academic Year Transfer' },
    { path: '/viewstudent', parent: 'Student Information', label: 'View Student' },
    { path: '/preview-confirm-enrollment', parent: 'Confirm Enrollment', label: 'Preview Confirm Enrollment' },
    { path: '/payment/success', parent: 'Finance', label: 'Payment Success' },
    { path: '/payment/failed', parent: 'Finance', label: 'Payment Failed' },
];